export const GET_PAYMENT_PLAN = 'GET_PAYMENT_PLAN';
